<template>
  <div style="display: flex; flex-direction: column; align-items: center; page-break-after: always" class="mb-4">
    <div v-if="!notChild" class="child-head">
      <div class="w-line" v-if="childW" :class="childW"></div>
      <div class="h-line"></div>
    </div>
    <table class="card">
      <colgroup>
        <col />
        <col width="176px" />
      </colgroup>
      <tbody>
        <tr>
          <td class="category font-bold" colspan="2">{{ value.category || "-" }}</td>
        </tr>
        <tr>
          <td colspan="2">{{ value.teamname || "-" }}</td>
        </tr>
        <tr>
          <td>{{ value.position || "-" }}</td>
          <td rowspan="2" style="width: 176px; height: 176px">
            <img v-if="value.photo" :src="value.photo.path" class="w-full h-full object-contain" />
          </td>
        </tr>
        <tr>
          <td>{{ value.name || "-" }}</td>
        </tr>
        <tr>
          <td colspan="2" style="height: 56px; min-height: 56px">
            <p class="print-textarea no-block min-h-0" style="background: none !important; word-break: break-word; padding: 0 6px !important">{{ value.description || "-" }}</p>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="0 < value.child.length" class="child-footer">
      <div class="h-line"></div>
    </div>

    <div :id="notChild ? `w-${value.level}` : ''" class="child flex">
      <PrintNode v-for="(c, c_i) in childData" :key="c.level" :value="c" :childW="childData.length === 1 ? false : c_i === 0 ? 'r' : c_i === childData.length - 1 ? 'l' : 'f'" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PrintNode",
  props: {
    value: Object,
    childW: Boolean | String,
    notChild: Boolean,
  },
  computed: {
    childData() {
      return this.value.child.filter((_c) => _c);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 280px;
  margin: 0 7px;

  &,
  td {
    text-align: center;
    border: solid 1px #cdcdcd;
  }

  td {
    position: relative;
    padding: 6px 0;

    &.category {
      background: #f9f9f9;
    }
  }
}

.img {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 14px);
  height: calc(100% - 14px);

  border-radius: 6px;
  border: 1px dashed #cdcdcd;
  margin: 7px;
}

.center-line {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  hr {
    border-top: 1px solid #cdcdcd;
  }
}

.child-head,
.child-footer {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;

  .w-line {
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #cdcdcd;

    &.r {
      right: 0;
      width: 50%;
    }
    &.l {
      left: 0;
      width: 50%;
    }
  }
  .h-line {
    display: block;
    width: 1px;
    height: 30px;
    background: #cdcdcd;
  }
}
</style>
